import { useBreakpointValue } from "@chakra-ui/react/hooks";
import SwitchAccount from "components/switch-account";
import React from "react";
import { Outlet, useParams } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import PrivateRoute from "./PrivateRoute";
import { useMerchantResolution } from "./use-merchant-resolution";

const MerchantPrivateRoute = () => {
  const isBaseSize = useBreakpointValue(
    { base: true, md: false },
    { ssr: false }
  );
  const { merchantId } = useParams();

  const { currentAgent, merchant } = useMerchantResolution({
    candidateMerchantId: merchantId ? parseInt(merchantId, 10) : undefined,
    allowInPlaceAdoption: true,
    persistSelectionOnAdopt: true,
    logoutOnMerchantError: true,
  });

  const { isSelectorOpened } = useAppSelector((state) => state.merchant);

  return (
    <>
      {isSelectorOpened && (!merchant || isBaseSize) ? null : (
        <PrivateRoute>
          <Outlet />
        </PrivateRoute>
      )}
      {!merchant || isBaseSize ? (
        <SwitchAccount
          required={true}
          merchants={currentAgent?.merchants || []}
        />
      ) : null}
    </>
  );
};

export default MerchantPrivateRoute;
